import { ca } from '@cian/analytics';
import { TAnalyticsUser, TProduct } from '../../../types/analytics';

export type TPage = {
  pageType: string;
  siteType: string;
  extra: {
    type: string;
    rating: number | null;
  };
};

export function trackReviewLinkAnalyticClick({
  user,
  page,
  product,
}: {
  user: TAnalyticsUser;
  page: TPage;
  product: TProduct;
}) {
  ca('eventSite', {
    name: 'oldevent',
    action: 'Click_sopr',
    category: 'Listing',
    label: 'Newbuilding_Rating',
    user,
    page,
    products: [product],
  });
}
